import { useMemo } from 'react';

import { useGetSurcharges } from 'queries';
import { useTranslation } from 'react-i18next';

import { getFormattedCostCenters } from '../utils/getFormattedCostCenters';
import { singleSelectValueFormatter } from 'components/shared/DataGrid/utils/valueFormatters/singleSelectValueFormatter';

import { GridColDef } from '@mui/x-data-grid-pro';

import LineClamp from 'components/shared/LineClamp';

export const useGetColumnDefs = () => {
  const { t } = useTranslation('common', { keyPrefix: 'surchargeRelations' });

  const { data: options } = useGetSurcharges();

  return useMemo(
    () =>
      [
        {
          field: 'clientBrDynId',
          type: 'string',
          headerName: t('client'),
          hideable: false,
          valueGetter: (params) =>
            getFormattedCostCenters({
              codeField: 'clientBrDynCode',
              fromField: 'clientBrDynValidFrom',
              toField: 'clientBrDynValidTo',
              nameField: 'clientBrDynName',
              item: params.row
            }),
          renderCell: (params) => (
            <LineClamp lineClamp={2} text={params.value} />
          ),
          filterable: false,
          minWidth: 250,
          flex: 1
        },
        {
          field: 'employerBrDynId',
          type: 'string',
          headerName: t('employer'),
          valueGetter: (params) =>
            getFormattedCostCenters({
              codeField: 'employerBrDynCode',
              fromField: 'employerBrDynValidFrom',
              toField: 'employerBrDynValidTo',
              nameField: 'employerBrDynName',
              item: params.row
            }),
          renderCell: (params) => (
            <LineClamp lineClamp={2} text={params.value} />
          ),
          filterable: false,
          minWidth: 250,
          flex: 1
        },
        {
          field: 'surchargeId',
          type: 'singleSelect',
          valueOptions: options,
          valueFormatter: (params) =>
            singleSelectValueFormatter(params, options ?? []),
          headerName: t('surchargeName'),
          filterable: false,
          minWidth: 100,
          flex: 1
        }
      ] as GridColDef[],
    [t, options]
  );
};
